import './techProjects.css';
import { FaYoutube, FaGithub } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import BeforeFooter from '../components/layout/BeforeFooter';

const projects = [
  {
    title: "Prospera – AI assistant empowering you to earn what you deserve",
    description:
      "Leverages Gemini AI to help women compare market salaries, train to negotiate, and get profile-tailored career tips.",
    github: "https://github.com/doniacld/prospera",
    youtube: "https://youtu.be/eeTv_fCXkmw?si=kFoGFaWntIIEaf70",
    award: "Winner – Best of Gender Equality, Google's Women Techmakers 'She Builds AI' Hackathon",
    tags: ["AI", "React", "Go", "Gemini", "Docker"],
  },
  {
    title: "Gluce – Personalized Metabolic Health Assessment Web App",
    description:
      "Analyzes user data with ML to predict metabolic health risks like metabolic syndrome, and delivers actionable insights to improve overall health.",
    github: "https://github.com/Elby2112/GLUCE",
    tags: ["Health", "AI", "Web App", "React", "Python"],
  },
  {
    title: "AppWhiz – An AI-Powered Game to Guess the App Behind a Fictional Story",
    description:
      "Read a fictional short story and guess which real-world app inspired it. A creative mix of storytelling, reasoning, and learning wrapped in fun gameplay.",
    github: "https://github.com/Elby2112/appwhiz-perplexity-backend",
    youtube: "https://youtu.be/fzAtj5TnM0M?si=owIwjTS-CgeIZdrl",
    tags: ["Game", "AI", "Perplexity", "React", "Python"],
  },
  {
    title: "PauZ – AI Journaling Assistant for Reflection & Insight",
    description:
      "An AI journaling assistant that helps users reflect on thoughts and feelings, providing personalized prompts and voice-powered insights.",
    github: "https://github.com/Elby2112/PAUZ",
    youtube: "https://www.youtube.com/watch?v=vQgk3l4Avk4&list=LL&index=1&t=24s",
    tags: ["AI", "React", "Raindrop", "LiquidmetalAI", "Vultr", "Elevenlabs", "Gemini", "FastAPI"],
  },
];

function TechProjects() {
  return (
    <>
      <section className="tech-projects-section">

        {/* ── Header ── */}
        <div className="tech-projects-header">
          <div className="prompt-line">
            <span className="prompt-symbol">❯</span>
            ls ~/projects --filter=tech
            <span className="cursor" />
          </div>
          <h1>Tech <span className="highlight">Projects</span></h1>
          <p className="subtitle">
            Side projects I build for fun, learning, and personal growth —
            usually involving AI and a lot of tea.
          </p>
         <div className="button-group">
  {/* <Link to="/cv" className="shared-button">
    <span>↗</span> ./view-cv
  </Link> */}
  <Link to="/portfolio" className="shared-button">
    <span>↗</span> portfolio
  </Link>
  
  <a
    href="https://github.com/Elby2112"
    target="_blank"
    rel="noopener noreferrer"
    className="shared-button"
    aria-label="View GitHub profile"
  >
    <FaGithub /> github
  </a>
</div>
        </div>

        {/* ── Divider ── */}
        <div className="section-divider">
          <span>{'// '}{projects.length} projects found</span>
        </div>

        {/* ── Cards ── */}
        <div className="project-card-container">
          {projects.map((proj, index) => (
            <article className="project-card" key={index}>
              <div className="project-content">

                {/* Number + title */}
                <div className="project-title-row">
                  <span className="card-num">
                    {String(index + 1).padStart(2, '0')} /
                  </span>
                  <h3>{proj.title}</h3>
                </div>

                {/* Award */}
                {proj.award && (
                  <div className="project-award">
                    🏆 {proj.award}
                  </div>
                )}

                {/* Description */}
                <p>{proj.description}</p>

                {/* Tags */}
                <div className="tech-tags">
                  {proj.tags?.map((tag, idx) => (
                    <span key={idx}>{tag}</span>
                  ))}
                </div>

                {/* Links */}
                <div className="card-links">
                  <a
                    href={proj.github}
                    target="_blank"
                    rel="noreferrer"
                    className="shared-button"
                    aria-label="View project on GitHub"
                  >
                    <FaGithub /> GitHub
                  </a>
                  {proj.youtube && (
                    <a
                      href={proj.youtube}
                      target="_blank"
                      rel="noreferrer"
                      className="shared-button youtube"
                      aria-label="Watch on YouTube"
                    >
                      <FaYoutube /> YouTube
                    </a>
                  )}
                </div>

              </div>
            </article>
          ))}
        </div>

      </section>
      <BeforeFooter />
    </>
  );
}

export default TechProjects;